import { render, staticRenderFns } from "./ParticipantForm.vue?vue&type=template&id=b2b4db6e&"
import script from "./ParticipantForm.vue?vue&type=script&lang=js&"
export * from "./ParticipantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports